// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { FormControl } from '@angular/forms';

export const orgDomainAliasValidator =
  (
    domainAlias: string | null | undefined,
    domains: string | null | undefined = ''
  ) =>
  (control: FormControl) => {
    if (!control.value) {
      return null;
    }

    const domain = (control.value || '')
      .substring((control.value || '').indexOf('@') + 1)
      .toLowerCase()
      .trim();

    if (!domain) {
      return { orgDomainAlias: true };
    }

    const normalizedDomains = (domains || '')
      .split(',')
      .map(d => d.toLowerCase().trim())
      .filter(d => d);

    const isMainDomainMatch = normalizedDomains.some(mainDomain => {
      if (domain === mainDomain) {
        return true;
      }

      if (domain.endsWith(`.${mainDomain}`)) {
        return true;
      }

      // Only match if domain has at least one dot and mainDomain has more labels
      if (domain.includes('.') && mainDomain.endsWith(`.${domain}`)) {
        return true;
      }

      return false;
    });

    if (isMainDomainMatch) {
      return null;
    }

    if (!domainAlias) {
      return { orgDomainAlias: true };
    }

    const normalizedAliases = domainAlias
      .split(',')
      .map(alias => alias.toLowerCase().trim())
      .filter(alias => alias);

    const isDomainAliasMatch = normalizedAliases.some(
      alias => domain === alias
    );

    return isDomainAliasMatch ? null : { orgDomainAlias: true };
  };
